export default {
  background: 'white'
}
